import React from 'react';
import PropTypes from 'prop-types';

import { Translation, Button, Link, Blurred } from '../../common';

import { PAY_NOW_TEXT_KEY } from '../../../constants/payment';
import { PAYMENTS } from '../../../constants/routes';

export const HEADER_KEY = 'HEADER';
export const DESCRIPTION_KEY = 'SUBHEADER';

const PayNow = ({ onPaymentClick, blur, styles }) => (
  <div className={styles['pay-now__content']}>
    <Blurred blur={blur}>
      <Translation className={styles['pay-now__header']}>
        {HEADER_KEY}
      </Translation>
      <Translation className={styles['pay-now__description']}>
        {DESCRIPTION_KEY}
      </Translation>
      <Link
        id="page.home.component.pay-now.pay-now-link"
        className={styles['pay-now__link']}
        to={PAYMENTS}
      >
        <Button
          id="page.home.component.pay-now.pay-now-button"
          className={styles['pay-now__button']}
        >
          <Translation>{PAY_NOW_TEXT_KEY}</Translation>
        </Button>
      </Link>
    </Blurred>
  </div>
);

PayNow.propTypes = {
  onPaymentClick: PropTypes.func,
  styles: PropTypes.object,
};

export default PayNow;
